// Login to cloud
export function login(loginSuccess, loginFailed, username, password) {
  window.cordova.exec(loginSuccess, loginFailed, "UniviewCameraPlugin", "loginAccount", [username, password]);
};

//Access to the video streaming page
export function accessVideoStream(accessSuccess, accessFail, numOfPlayers) {
  var array = sessionStorage.getItem('devices'); //array of devices
  window.cordova.exec(accessSuccess, accessFail, "UniviewCameraPlugin", "accessDevice", [array, numOfPlayers]);
};